// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"768e0931","584":"70d644da"}[chunkId] + ".chunk.css";
};